<template>
    <div></div>
</template>
<script>
export default {
    name: 'RootRouterView',
    components: {},
    data() {
        return {};
    },
    methods: {},
    mounted() {
        // 已登入，跳至公司首頁
        if (this.$store.getters['account/isLoggedIn']) {
            this.$router.push(`/${this.$store.getters['account/company']}/index`);
        }

        // 未登入，跳至登入頁面
        else {
            this.$router.push('/login');
        }
    },
};
</script>
<style lang="scss" scoped=""></style>
